import * as React from 'react';
import { fileAvatar } from 'utils/utils.files';
import { JRCFileProps } from './types';

export const JRCFileAudio = ({ uri, mimetype = 'audio/mp3', display }: JRCFileProps) => {
    const file = fileAvatar(mimetype);
    return uri !== undefined && display !== 'avatar' ? (
        <audio controls={true} preload="none">
            <source src={uri} type={mimetype}></source>
        </audio>
    ) : (
        <img src={file.path} />
    );
};
